import React, {useEffect, useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {useListStyles} from './MenuStyles';
import {
  AssignmentOutlined,
  BarChart,
  ContactsOutlined,
  EventOutlined,
  ExpandLess,
  ExpandMore,
  ExploreOutlined,
  FolderOpen,
  MonetizationOnOutlined,
  PageviewOutlined,
  Settings,
} from '@mui/icons-material';
import {ItemsCommon} from './ItemsCommon';
import {getMyProfilePathFromUserId, NavigationPath} from '../SelectedIndexUtil';
import {getProfileImage} from '../../../../util/UserUtils';
import {theme} from '../../../../Theme';
import {useRecoilValue} from 'recoil';
import {firestoreUserState} from '../../../../recoil/user/userAtom';
import useBidmiiProTier from '../../../../common/useBidmiiProTier';
import Anchor from '../../../../common/Anchor';

interface IProps {
  user: any;
  width: number;
  selectedIndex: NavigationPath;
  handleListItemClick: (navigationPath: NavigationPath) => void;
  handleProfileListItemClick: (navigationPath: string) => void;
  handleLogoutClick: () => void;
  setDrawerOpen: (open: boolean) => void;
}

export const ItemsContractor: React.FC<IProps> = (props) => {
  const firestoreUser = useRecoilValue(firestoreUserState);
  const proTier = useBidmiiProTier();

  const classes = useListStyles(props.width)();
  const [accountingOpen, setAccountingOpen] = useState(false);
  const {selectedIndex, handleListItemClick, handleProfileListItemClick} =
    props;
  // const isMobileLayout = props.width < 601;

  useEffect(() => {
    [NavigationPath.ANALYTICS, NavigationPath.INVOICES].includes(
      selectedIndex,
    ) && setAccountingOpen(true);
  }, [selectedIndex]);

  return (
    <List className={classes.listRoot}>
      <Anchor href={NavigationPath.HOME}>
        <ListItem
          button
          key={NavigationPath.HOME}
          selected={selectedIndex === NavigationPath.HOME}
          onClick={(e) => handleListItemClick(NavigationPath.HOME)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          <ListItemIcon>
            <BarChart />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="DASHBOARD"
          />
        </ListItem>
      </Anchor>
      <Divider style={{margin: '4px 0'}} />
      <Anchor href={NavigationPath.RFPS}>
        <ListItem
          button
          key={NavigationPath.RFPS}
          selected={selectedIndex === NavigationPath.RFPS}
          onClick={() => handleListItemClick(NavigationPath.RFPS)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <PageviewOutlined />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="AVAILABLE JOBS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_AWARDED_RFPS}>
        <ListItem
          button
          key={NavigationPath.MY_AWARDED_RFPS}
          selected={selectedIndex === NavigationPath.MY_AWARDED_RFPS}
          onClick={() => handleListItemClick(NavigationPath.MY_AWARDED_RFPS)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <FolderOpen />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="MY PROJECTS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_SITE_VISITS}>
        <ListItem
          button
          key={NavigationPath.MY_SITE_VISITS}
          selected={selectedIndex === NavigationPath.MY_SITE_VISITS}
          onClick={() => handleListItemClick(NavigationPath.MY_SITE_VISITS)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <EventOutlined />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="SITE VISITS"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_PROPOSALS}>
        <ListItem
          button
          disableGutters
          key={NavigationPath.MY_PROPOSALS}
          selected={selectedIndex === NavigationPath.MY_PROPOSALS}
          onClick={() => handleListItemClick(NavigationPath.MY_PROPOSALS)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <AssignmentOutlined />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="QUOTES"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.MY_CONTACTS}>
        <ListItem
          button
          disableGutters
          key={NavigationPath.MY_CONTACTS}
          selected={selectedIndex === NavigationPath.MY_CONTACTS}
          onClick={() => handleListItemClick(NavigationPath.MY_CONTACTS)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <ContactsOutlined />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="CONTACTS"
          />
        </ListItem>
      </Anchor>
      <Divider style={{margin: '4px 0'}} />
      {proTier > 1 && firestoreUser && !firestoreUser.proSetupComplete && (
        <Anchor href={NavigationPath.PRO_SETUP}>
          <ListItem
            button
            disableGutters
            key={NavigationPath.PRO_SETUP}
            selected={selectedIndex === NavigationPath.PRO_SETUP}
            onClick={() => handleListItemClick(NavigationPath.PRO_SETUP)}
            classes={{
              root: classes.drawerItemRoot,
              selected: classes.drawerItemSelected,
            }}>
            {/* {isMobileLayout && ( */}
            <ListItemIcon>
              <img
                src={
                  'https://cdn.bidmii.com/media/web_assets/small-diamond.svg'
                }
                style={{
                  width: 20,
                  marginLeft: 2,
                }}
              />
            </ListItemIcon>
            {/* )} */}
            <ListItemText
              primaryTypographyProps={{
                variant: 'subtitle2',
                style: {color: theme.palette.blue.dark},
              }}
              primary="PRO SETUP"
            />
          </ListItem>
        </Anchor>
      )}
      <Anchor href={NavigationPath.RESOURCES}>
        <ListItem
          button
          key={NavigationPath.RESOURCES}
          selected={selectedIndex === NavigationPath.RESOURCES}
          onClick={() => handleListItemClick(NavigationPath.RESOURCES)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <ExploreOutlined />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="RESOURCES"
          />
        </ListItem>
      </Anchor>
      <Anchor href={getMyProfilePathFromUserId(props.user?.id)}>
        <ListItem
          button
          key={getMyProfilePathFromUserId(props.user?.id)}
          selected={
            selectedIndex === getMyProfilePathFromUserId(props.user?.id)
          }
          onClick={() =>
            handleProfileListItemClick(
              getMyProfilePathFromUserId(props.user?.id),
            )
          }
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <Avatar
              aria-label="userProfileAvatarMenu"
              className={classes.avatar}
              src={getProfileImage(props.user, '100x100')}
            />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="MY PROFILE"
          />
        </ListItem>
      </Anchor>
      <Anchor href={NavigationPath.DASHBOARD}>
        <ListItem
          button
          disableGutters
          key={NavigationPath.DASHBOARD}
          selected={selectedIndex === NavigationPath.DASHBOARD}
          onClick={() => handleListItemClick(NavigationPath.DASHBOARD)}
          classes={{
            root: classes.drawerItemRoot,
            selected: classes.drawerItemSelected,
          }}>
          {/* {isMobileLayout && ( */}
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          {/* )} */}
          <ListItemText
            primaryTypographyProps={{variant: 'subtitle2'}}
            primary="SETTINGS"
          />
        </ListItem>
      </Anchor>
      <ListItem
        button
        disableGutters
        key="accounting"
        onClick={() => setAccountingOpen(!accountingOpen)}
        classes={{
          root: classes.drawerItemRoot,
          selected: classes.drawerItemSelected,
        }}>
        {/* {isMobileLayout && ( */}
        <ListItemIcon>
          <MonetizationOnOutlined />
        </ListItemIcon>
        {/* )} */}
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="ACCOUNTING"
        />
        {accountingOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={accountingOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Anchor href={NavigationPath.ANALYTICS}>
            <ListItem
              button
              disableGutters
              key={NavigationPath.ANALYTICS}
              selected={selectedIndex === NavigationPath.ANALYTICS}
              onClick={() => handleListItemClick(NavigationPath.ANALYTICS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}
              style={{marginLeft: 16}}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="ANALYTICS"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.INVOICES}>
            <ListItem
              button
              disableGutters
              key={NavigationPath.INVOICES}
              selected={selectedIndex === NavigationPath.INVOICES}
              onClick={() => handleListItemClick(NavigationPath.INVOICES)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}
              style={{marginLeft: 16}}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="INVOICES"
              />
            </ListItem>
          </Anchor>
        </List>
      </Collapse>
      <Divider style={{margin: '4px 0'}} />
      <ItemsCommon
        width={props.width}
        isLoggedIn={true}
        selectedIndex={selectedIndex}
        handleListItemClick={handleListItemClick}
        handleLogoutClick={props.handleLogoutClick}
      />
    </List>
  );
};
